import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SharedDocumentReferencesService } from '@app/shared/services/shared-document-references.service';
import { ShellService } from '@mynexus/mfe-core';
import { ProductNames } from '@mynexus/mynexus-ui-lib';



@Injectable({
  providedIn: 'root',
})
export class DocumentReferencesPACService extends SharedDocumentReferencesService {
 constructor(
    http: HttpClient,
    shellService: ShellService
  ) {
    super(http, shellService, ProductNames.PACIM)
  }

  override getUploadMessage(authorizationNumber: string ,isExternal: boolean) : { severity: string; summary: string; detail: string; }
    {
    const detail = `You will be uploading additional files to Authorization ${authorizationNumber}. Uploading additional
    information does NOT constitute a new request.To request further authorization, go to Services tab and click the button to complete a request.`;
    if(isExternal)
    return { severity: 'warn', summary: 'Alert:', detail }
    else
    return null
  }

}
